import React, { useState, useEffect } from "react";
import './catering-radio-group.scss'
import { useDispatch } from 'react-redux';
import {
    handleUpdateCateringAndMealCartCustomOption
} from "redux/actions";

const CateringRadioGroup = ({
    groupData,
    custom_options_arr,
    productIndex,
    setShowProductButton
}) => {
    const dispatch = useDispatch()
    const { values, title, is_required, title: label, is_add_option_price, id: groupId } = groupData

    const [selectedOption, setSelectedOption] = useState();

    useEffect(() => {

        const defaultSelectedOption = custom_options_arr.find(option => option.option_id === groupId)
        defaultSelectedOption && setSelectedOption(defaultSelectedOption.value)

    }, [custom_options_arr]) // eslint-disable-line


    const handleChangeOption = (optionValue, option) => {
        const { id, option_id, price, value } = option
        setSelectedOption(optionValue)
        dispatch(handleUpdateCateringAndMealCartCustomOption({ [groupId]: [{ id, is_add_option_price, label, option_id, price, value }] }, productIndex, true))
        setShowProductButton()
    }
    return (
        <div className="catering-radio-group">
            <p><strong>{title}</strong>{is_required === "1" && <span>*</span>}</p>
            <div className="catering-radio-group-item-list">
                {values && values.length && values.map((option => {
                    return <div className="catering-item-with-radio" key={option.id}>
                        <input
                            type="radio"
                            id={option.id + productIndex}
                            onChange={() => handleChangeOption(option.value, option)}
                            checked={option.value === selectedOption}
                        />
                        <label htmlFor={option.id + productIndex}>
                            <span>{option.value} {option.price !== "0.00" ? `- $${option.price}` : ""}</span>
                        </label>
                    </div>
                }))}
            </div>
        </div>
    );
};

export default CateringRadioGroup;
